import { render, staticRenderFns } from "./lkuApLazzy.vue?vue&type=template&id=483e533c&"
import script from "./lkuApLazzy.vue?vue&type=script&lang=js&"
export * from "./lkuApLazzy.vue?vue&type=script&lang=js&"
import style0 from "./lkuApLazzy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports